import type { Apps, Environment } from '@awork/environments/types'

export const environment: Environment = 'develop',
  apiEndpoint = 'https://api.cwork.io/api/v1',
  apiEndpointV2 = 'https://api.cwork.io/api/v2',
  apiHostname = 'cwork.io',
  apiProtocol = 'https://',
  assetsUrl = '/assets/',
  clientSecret = 'LUoJXFBCgLDKXmp0BcXawA7osttZAGhZfkIYAyKafqZ3bfSkMtxk',
  mobileAppClientCredentials = '>>APP_CLIENT_CREDENTIALS',
  releaseName = '>>RELEASE_NAME',
  buildName = '>>BUILD_NAME',
  version = '2.2.71',
  buildNumber = '136',
  app: Apps = 'mobile',
  pushNotificationSenderId = '561151912625',
  microsoftClientId = 'e97af600-30ec-417f-aca5-04adbf3d6c6f',
  isLiveMobile = true
